import { createPortal } from 'react-dom';
import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import { observer } from 'mobx-react-lite';

import Loader from 'src/components/common/loader';
import PaymentButtons from '../payment-buttons';
import PaymentLogos from '../payment-logos';

import paymentStore from 'src/stores/payment-store';

import { useStripeContext } from 'src/contexts';
import useStripePayment from 'src/hooks/use-stripe-payment';
import type { StripeFormProps } from './stripe-form.props';

import './stripe-form.scss';

const CARD_OPTIONS = {
  style: {
    base: {
      iconColor: '#3b3b3b',
      fontSize: '16px',
      fontWeight: '400',
      textTransform: 'uppercase',
      color: '#3b3b3b',
      '::placeholder': {
        color: '#808080',
      },
    },
    invalid: {
      color: '#d95151',
    },
  },
};

const StripeForm = observer(({ form }: StripeFormProps) => {
  const { stripe } = useStripeContext();
  const handleCardPaymentButtonClick = useStripePayment(paymentStore);

  if (!stripe) {
    return <Loader className="loader_position_overlay" />;
  }

  return (
    <div className="stripe-form">
      <div className="stripe-form__card-form">
        <CardNumberElement
          className="stripe-form__input  stripe-form__input_card"
          options={CARD_OPTIONS}
          onChange={paymentStore.handleCardElementChange}
        />
        <CardExpiryElement
          className="stripe-form__input  stripe-form__input_expiry"
          options={CARD_OPTIONS}
          onChange={paymentStore.handleExpiryElementChange}
        />
        <CardCvcElement
          className="stripe-form__input  stripe-form__input_cvc"
          options={CARD_OPTIONS}
          onChange={paymentStore.handleCvcElementChange}
        />
      </div>
      {createPortal(
        <>
          <PaymentButtons onPaymentButtonClick={handleCardPaymentButtonClick} />
          <PaymentLogos />
        </>,
        form
      )}
    </div>
  );
});

export default StripeForm;
